<div class=" content-banner-main">
    <app-banner-reason></app-banner-reason>
    <div class="fono-banner d-lg-block d-none">
    </div>
</div>
<div>
  <app-estadistics-reason></app-estadistics-reason>
</div>
<app-nuestros-aliados></app-nuestros-aliados>
<div class="px-4 px-xxl-5 pb-5">
    <app-nuestro-equipo></app-nuestro-equipo>
      <app-nuestro-equipo-media></app-nuestro-equipo-media>
</div>

